export const ROUTES = {
  AUTH_ROUTES: {
    BASE: "/auth",
    LOGIN: "/auth/login",
    REGISTER: "/auth/register",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: "/auth/reset-password",
    VERIFY_CODE: "/auth/verify-code",
  },

  APP_ROUTES: {
    BASE: "/app",
    DASHBOARD: "/app/dashboard",
    SERVICES: "/app/services",
    SUPPORT: "/app/support",
  },

  PUBLIC: {
    HOME: "/",
  },
} as const;